<template>
  <div class="permissions-table-container">
    <table class="table w-auto">
      <tbody>
        <tr v-for="(moduleData, moduleSlug) in permissionModules" :key="moduleSlug">
          <td class="p-1 pr-4" style="vertical-align: middle;">
            <button 
              type="button" 
              class="btn btn-outline-primary d-flex align-items-center justify-content-between gap-3 pr-3 w-100" 
              @click="toggleAllModulePermissions(moduleSlug)" 
              title="Clique para ativar/desativar todas as permissões"
            >
              {{ moduleData.name }}
              <i class="mdi mdi-chevron-double-right bg-primary text-white d-inline-block rounded-pill" style="width: 1.5em; height: 1.5em;"></i>
            </button>
          </td>
          <td 
            v-for="(actionName, actionSlug) in permissionActions" 
            :key="actionSlug"
            class="p-1" 
            style="vertical-align: middle;"
          >
            <label class="card card-body border shadow p-3 d-block check-card user-select-none" style="flex: 0 0 150px;">
              <input
                type="checkbox"
                :name="`permissoes[${moduleSlug}][${actionSlug}]`"
                :id="`permissao-${moduleSlug}-${actionSlug}`"
                value="1"
                :class="`form-control permissao-${moduleSlug}`"
                v-model="selectedPermissions[moduleSlug][actionSlug]"
                @change="handlePermissionChange(moduleSlug, actionSlug, $event.target)"
                :disabled="isActionDisabled(moduleSlug, actionSlug)"
                :title="isActionDisabled(moduleSlug, actionSlug) ? 'Ação não permitida para este módulo' : ''"
              >
              <span class="permission-label">{{ actionName }}</span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>


  </div>
</template>

<script>
export default {
  name: 'PermissionsTable',
  props: {
    permissionModules: {
      type: Object,
      required: true
    },
    permissionActions: {
      type: Object,
      required: true
    },
    selectedPermissions: {
      type: Object,
      required: true
    },
    permissionsMatrix: {
      type: Object,
      required: true
    }
  },
  methods: {
    isActionDisabled(moduleSlug, actionSlug) {
      const moduleData = this.permissionModules[moduleSlug];
      
      // Check blacklist (existing logic)
      if (moduleData && moduleData.blacklist && moduleData.blacklist.includes(actionSlug)) {
        return true;
      }
      
      // Check if permission_slug is null in the matrix
      if (this.permissionsMatrix && this.permissionsMatrix[moduleSlug]) {
        const moduleMatrix = this.permissionsMatrix[moduleSlug];
        
        // For 'acesso' action, check both 'list' and 'show' permissions
        if (actionSlug === 'acesso') {
          const listPermission = moduleMatrix.permissions && moduleMatrix.permissions['list'];
          const showPermission = moduleMatrix.permissions && moduleMatrix.permissions['show'];
          
          // Disable if either list or show permission has null permission_slug
          if ((listPermission && listPermission.permission_slug === null) || 
              (showPermission && showPermission.permission_slug === null)) {
            return true;
          }
        } else {
          // For other actions, check the specific permission
          const permission = moduleMatrix.permissions && moduleMatrix.permissions[actionSlug];
          if (permission && permission.permission_slug === null) {
            return true;
          }
        }
      }
      
      return false;
    },
    
    toggleAllModulePermissions(moduleSlug) {
      const modulePermissions = this.selectedPermissions[moduleSlug];
      const enabledActions = Object.keys(this.permissionActions).filter(
        actionSlug => !this.isActionDisabled(moduleSlug, actionSlug)
      );
      const allChecked = enabledActions.every(actionSlug => modulePermissions[actionSlug]);
      
      const newPermissions = { ...this.selectedPermissions };
      enabledActions.forEach(actionSlug => {
        newPermissions[moduleSlug][actionSlug] = !allChecked;
      });
      
      this.$emit('permissions-changed', newPermissions);
    },
    
    handlePermissionChange(moduleSlug, actionSlug, target) {
      const newPermissions = { ...this.selectedPermissions };
      
      if (actionSlug === 'acesso') {
        // "Acesso" representa list + show no backend
        // Quando marcado/desmarcado, afeta apenas essas duas permissions virtuais
        const isChecked = target.checked;
        newPermissions[moduleSlug][actionSlug] = isChecked;
      } else {
        // Para outras ações, apenas atualiza o estado atual
        newPermissions[moduleSlug][actionSlug] = target.checked;
      }
      
      this.$emit('permissions-changed', newPermissions);
    }
  }
};
</script>

<style scoped>
.check-card:has(input[type=checkbox]:disabled) {
  cursor: not-allowed !important;
  filter: grayscale(1);
  opacity: 0.3 !important;
}

.check-card:has(input[type=checkbox]:disabled)::after {
  content: "\f0c8";
  content: "\f05e";
  font-weight: 900;
  opacity: 0.25;
  pointer-events: none;
}

.permission-label {
  text-transform: capitalize;
}
</style>